import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
  url: "https://keycloak.smartdemo.live",
  realm: "MediaNest",
  clientId: "medianestclient",
});

// Refresh the token 30 seconds before it expires.
// If refresh fails (e.g. session ended server-side), force logout so the
// user is redirected to the Keycloak login page cleanly.
keycloak.onTokenExpired = () => {
  keycloak.updateToken(30).catch(() => {
    keycloak.logout({ redirectUri: window.location.origin });
  });
};

export default keycloak;
